import React, { useCallback } from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import createLogger from '~/src/Lib/Logging'

import SnackbarNotification from '../SnackbarNotification'
import useIrrigationScheduleChangeNotification
  from './useIrrigationScheduleChangeNotificationEntity'

const displayName = 'Notification/IrrigationChange'
const logger = createLogger(displayName)

const IrrigationChangeNotification = ({
  harvest,
  nextPhase,
  nextSchedule,
  doAcknowledgeNotification,
  onView,
}) => {
  const {
    routeInfo,
    doUpdateUrl,
  } = useConnect(
    'selectRouteInfo',
    'doUpdateUrl',
  )

  const handleReviewIrrigationChange = useCallback(async () => {
    await doAcknowledgeNotification()
    const pageRoute = `/harvests/${harvest.id}/schedule`
    const dialogRoute = `#/irrigationSchedules/${nextSchedule.id}/edit?verify=true`
    doUpdateUrl(pageRoute + dialogRoute)
  }, [doAcknowledgeNotification, doUpdateUrl, harvest.id, nextSchedule.id])

  return (
    <SnackbarNotification
      hide={routeInfo.pattern === '/harvests/:id/schedule'}
      harvest={harvest}
      nextPhase={nextPhase}
      onDismiss={doAcknowledgeNotification}
      onReview={handleReviewIrrigationChange}
      onView={onView}
    />
  )
}

IrrigationChangeNotification.propTypes = {
  harvest: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  nextPhase: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  nextSchedule: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  doAcknowledgeNotification: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
}

const Wrapped = () => {
  const {
    // notification,
    // currentPhase,
    // currentSchedule,
    harvest,
    nextPhase,
    nextSchedule,
    doAcknowledgeNotification,
    doViewNotification,
  } = useIrrigationScheduleChangeNotification()

  if (!harvest || !nextPhase || !nextSchedule) return null

  return (
    <IrrigationChangeNotification
      harvest={harvest}
      nextPhase={nextPhase}
      nextSchedule={nextSchedule}
      doAcknowledgeNotification={doAcknowledgeNotification}
      onView={doViewNotification}
    />
  )
}

const Memoized = React.memo(Wrapped)

export default Memoized
